export const SET_TIME_ENTRIES = 'SET_TIME_ENTRIES'
